var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-page',[_c('ws-data-table',{staticClass:"mt-5",attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.registered",fn:function(ref){
var item = ref.item;
return [_c('h5',[_vm._v(_vm._s(_vm.PARSE_DATE(item.registered , false , true)))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }